$(function () {
  new Swiper('.careers__team .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      nextButton: '.careers__team .icon-angle-right',
      prevButton: '.careers__team .icon-angle-left'
  })

  var swiperButtons = document.querySelector('.careers__team .swiper-buttons')
  var nextEl = document.querySelector('.careers__team .icon-angle-right')
  var prevEl = document.querySelector('.careers__team .icon-angle-left')

  setFog()

  var observer = new MutationObserver(function () {
    setFog()
  })
  
  observer.observe(swiperButtons, {
    childList: true, 
    subtree: true,
    attributes: true
  })

  function setFog() {
    var buttons = [nextEl, prevEl]

    buttons.forEach(function(e) {
      var id = e.dataset.buttonId
      var fog = document.querySelector('span[data-span-id="' + id + '"]')

      if(e.classList.contains('swiper-button-disabled')) {
        fog.classList.add('hidden')
      } else {
        fog.classList.remove('hidden')
      }
    })
  }
})